import { registerPlugin } from '@capacitor/core';

export interface Terminal {
  ipAddress: string;
  port: number;
  compatibilityPort: number;
  socketMode: string;
  terminalType: string;
}

export interface PeriodCloseResult {
  merchantReceipt: string;
}

export interface PaymentResult {
  transactionId: string;
}

interface PaymentRemoteTerminalPlugin {
  makePayment: (data: {amount: string; currency: string; terminal: Terminal}) => Promise<PaymentResult>;
  cancelPayment: (data: {terminal: Terminal}) => Promise<void>;
  closePeriod: (data: {terminal: Terminal}) => Promise<PeriodCloseResult>;
  getTerminalStatus: (data: {terminal: Terminal}) => Promise<{status: string}>;
  revertPayment: (data: {transactionId: string; terminal: Terminal}) => Promise<void>;
  refundPayment: (data: {transactionId: string; amount: string; currency: string; terminal: Terminal}) => Promise<void>;
}

const PaymentRemoteTerminal = registerPlugin<PaymentRemoteTerminalPlugin>('PaymentRemoteTerminal');

export default PaymentRemoteTerminal;
